import { Component, EventEmitter, Output } from '@angular/core';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';


@Component({
  selector: 'aig-modal-open-claim',
  imports: [ModalComponent],
  templateUrl: './modal-open-claim.component.html',
  styleUrl: './modal-open-claim.component.scss'
})
export class ModalOpenClaimComponent {
  @Output() hideModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  clickHide(): void {
    this.hideModal.emit(true);
  }
  public readonly supportEmail: string = 'backoffice.caixa@icp.es';
}
